/**
 * Open size guide popup
**/

$('.js-size-guide').magnificPopup({
  type: 'inline',
  preloader: false,
  modal: true
});